import type { SmsTestStatus } from "services/SmsTestService";

export const SMS_TEST_PHONE_PATTERN = /^5\d{9}$/;

export const isSmsTestPhoneValid = (value?: string | null): boolean => {
  return SMS_TEST_PHONE_PATTERN.test(String(value ?? "").trim());
};

export const getSmsTestStatusMeta = (status?: SmsTestStatus | null) => {
  switch (status) {
    case "SUCCESS":
      return { label: "Başarılı", color: "success" as const };
    case "FAILED":
      return { label: "Başarısız", color: "error" as const };
    case "DRAFT":
    default:
      return { label: "Taslak", color: "default" as const };
  }
};
